import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getIsMarketOptional,
} from 'dash-common';
import { Flex, Form, FormContext, type SelectProps } from 'dash-ui';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const MarketAreaSelect: FC<SelectProps> = ({ ...selectProps }) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formErrors, formState, stateHandlers } = useContext(FormContext);
  const { state = '' } = formState || {};

  const isMarketOptional = getIsMarketOptional(state);

  return (
    <Flex flexDirection="column" flex={1}>
      <Form.Label required={!isMarketOptional}>
        {t('forms:labels.marketArea')}
      </Form.Label>
      <Form.Select
        menuPortalZIndex="auto"
        value={formState.market}
        placeholder={t('forms:placeholders.selectOne')}
        w="100%"
        options={[
          {
            label: formState.market,
            value: formState.market,
          }
        ]}
        onChanged={() => {}}
        $errorType={formErrors[FormFields.Market]?.type}
        {...selectProps}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Market]?.type}>
        {formErrors[FormFields.Market]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default MarketAreaSelect;
